// // src/utils/dateHelpers.ts
// export const safeToDate = (timestampOrDate: any): Date | null => {
//   if (!timestampOrDate) return null;
//   if (timestampOrDate.toDate) return timestampOrDate.toDate();
//   if (timestampOrDate instanceof Date) return timestampOrDate;
//   try {
//     const d = new Date(timestampOrDate);
//     return isNaN(d.getTime()) ? null : d;
//   } catch {
//     return null;
//   }
// };

import { Timestamp } from "firebase/firestore";

/**
 * Safely converts a Firestore Timestamp, Date, number, or string
 * into a JavaScript Date. Returns null if it can't convert.
 */
export function safeToDate(
  value: Timestamp | Date | number | string | null | undefined
): Date | null {
  if (!value) return null;

  // Already a JS Date
  if (value instanceof Date) return value;

  // Firestore Timestamp
  if (typeof (value as any).toDate === "function") {
    return (value as Timestamp).toDate();
  }

  // Numeric timestamp (seconds or ms)
  if (typeof value === "number") {
    return value < 10_000_000_000 ? new Date(value * 1000) : new Date(value);
  }

  // String date (ISO or RFC2822)
  if (typeof value === "string") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  return null;
}

